import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import { analytics } from '../utils/analytics';

export default function Menu() {
  const [open, setOpen] = useState(false);
  const menuButton = useRef(null);
  const location = useLocation();
  useEffect(() => { setOpen(false); }, [location.pathname, location.hash]);
  return (
    <header className="site-header" onKeyDown={event => {
      if (event.key === 'Escape') { setOpen(false); menuButton.current?.focus(); }
    }}>
      <a href="#contenido" className="skip-link">Saltar al contenido</a>
      <div className="container header-row">
        <Link to="/" className="personal-mark">Ray Saracual<span>Ingeniería de software</span></Link>
        <button ref={menuButton} type="button" className="menu-button" aria-label={open ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={open} aria-controls="main-navigation" onClick={() => { setOpen(!open); analytics.trackMenuInteraction(open ? 'close' : 'open', 'main-navigation'); }}><FontAwesomeIcon icon={open ? faXmark : faBars} /></button>
        <nav id="main-navigation" className="site-navigation" data-open={open} aria-label="Navegación principal">
          <NavLink to="/" end onClick={() => { setOpen(false); analytics.trackNavigation('/'); }}>Inicio</NavLink>
          <NavLink to="/projects" onClick={() => { setOpen(false); analytics.trackNavigation('/projects'); }}>Proyectos</NavLink>
          <NavLink to="/summary" onClick={() => { setOpen(false); analytics.trackNavigation('/summary'); }}>Trayectoria</NavLink>
          <Link to="/#contacto" className="button primary" onClick={() => { setOpen(false); analytics.trackNavigation('/#contacto'); }}>Contactar</Link>
        </nav>
      </div>
    </header>
  );
}


